import type {Permission, PermissionType} from '@hconnect/apiclient'

import type {PermissionParsed} from '../types'

/**
 * Parses permissions data scopes and optionally filters by permission types
 * @param permissions - Array of raw permissions from API
 * @param permissionTypes - Optional array of permission types to filter by
 * @returns Array of parsed permissions, optionally filtered
 */
export const parseAndFilterPermissions = (
  permissions: Permission[],
  permissionTypes?: PermissionType[]
): PermissionParsed[] => {
  const permissionsParsed: PermissionParsed[] = permissions.map((permission) => ({
    ...permission,
    parsedDataScope: JSON.parse(permission.dataScope) as PermissionParsed['parsedDataScope']
  }))

  return permissionTypes
    ? permissionsParsed.filter((entry) => permissionTypes.includes(entry.permissionType))
    : permissionsParsed
}
